import {useEffect} from "react";

export default function TermsOfUse({className, ...props}) {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    return (
        <div className="terms-of-use container mx-auto p-6 bg-gray-50 rounded-lg shadow-md">
            <h1 className="text-3xl font-bold text-center text-gray-800 mb-6">Terms of Use</h1>
            <p className="text-gray-700 mb-4">
                These Terms of Use ("Terms") govern your use of Detstudy ("the Website"), owned and operated by
                [DetStudy].
                By accessing or using the Website, you agree to be bound by these Terms. If you do not agree to these
                Terms,
                please do not use the Website.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">Use of the Website</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>You must be at least 18 years old to use the Website.</li>
                <li>You are responsible for all activities conducted through your account.</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">Content</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>All content provided on the Website is for informational and educational purposes related to the
                    Duolingo English Test.
                </li>
                <li>You may not reproduce, distribute, or transmit any content from the Website without prior written
                    permission.
                </li>
                <li>We reserve the right to modify or remove any content on the Website at any time.</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">User Conduct</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>You agree not to engage in any activity that may disrupt or interfere with the functioning of the
                    Website.
                </li>
                <li>You may not use the Website for any unlawful or unauthorized purpose.</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">Intellectual Property</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>All intellectual property rights related to the Website and its content are owned by DetStudy.</li>
                <li>You may not use any trademarks, logos, or other proprietary information without our express written
                    consent.
                </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">Privacy</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Your use of the Website is subject to our Privacy Policy.</li>
                <li>By using the Website, you consent to the collection and use of your information as described in the
                    Privacy Policy.
                </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">Limitation of Liability</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>We are not liable for any damages or losses resulting from your use of the Website.</li>
                <li>We make no warranties or representations about the accuracy or completeness of the content on the
                    Website.
                </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">Indemnification</h2>
            <p className="text-gray-700 mb-4">
                You agree to indemnify and hold harmless DetStudy and its affiliates from any claims, damages, or losses
                arising out of your use of the Website or violation of these Terms.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">Changes to Terms</h2>
            <p className="text-gray-700 mb-4">
                We reserve the right to update or modify these Terms at any time. By continuing to use the Website after
                changes are posted,
                you agree to be bound by the revised Terms.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">Contact Us</h2>
            <p className="text-gray-700">
                If you have any questions about these Terms, please contact us at <a href="mailto:Detstudynow@gmail.com"
                                                                                     className="text-blue-600 underline">Detstudynow@gmail.com</a>.
            </p>
        </div>

    )
}